import { z } from "zod";

export const VOICE_GUESSER_NOTIFICATION_TYPE = "voice_guesser_invite" as const;

export const voiceGuesserInviteDataSchema = z.object({
	type: z.literal(VOICE_GUESSER_NOTIFICATION_TYPE),
	group_id: z.string(),
	game_id: z.string(),
	host_name: z.string(),
});

export type VoiceGuesserInviteData = z.infer<typeof voiceGuesserInviteDataSchema>;

const VOICE_GUESSER_RESOURCE_SEPARATOR = ":";

export const buildVoiceGuesserResourceId = (groupId: string, gameId: string): string =>
	`${groupId}${VOICE_GUESSER_RESOURCE_SEPARATOR}${gameId}`;

export const voiceGuesserResourceIdSchema = z.string().transform((raw, ctx) => {
	const [groupId, gameId, ...rest] = raw.split(VOICE_GUESSER_RESOURCE_SEPARATOR);
	if (!groupId || !gameId || rest.length > 0) {
		ctx.addIssue({ code: z.ZodIssueCode.custom, message: "invalid_voice_guesser_resource_id" });
		return z.NEVER;
	}
	return { group_id: groupId, game_id: gameId };
});

export type VoiceGuesserResourceId = z.infer<typeof voiceGuesserResourceIdSchema>;
